import { swapImgSources } from '@/scripts/utils/base';

export default class Slider {
   _cur = 0;
   _ready = true;

   /** @param {HTMLElement} root */
   constructor(root) {
      this.$root = root;
      this._init();
   }

   _init() {
      this._getElements();
      this._initEvents();
   }

   next() {
      this.goto(this._cur + 1);
   }

   prev() {
      this.goto(this._cur - 1);
   }

   goto(index) {
      if (!this._ready || index === this._cur) return;
      this._ready = false;

      index = this._loopIndex(index);
      const slide = this.$slides[index];

      this.$curIndex.innerHTML = index + 1;

      slide.classList.add('slider--item__top');
      slide.classList.add('slider--item__visible');

      slide.addEventListener('transitionend', () => {
         this.$slides[index].classList.remove('slider--item__top');
         this.$slides[this._cur].classList.remove('slider--item__visible');
         this._cur = index;
         this._ready = true;
      }, { once: true });

      [-2, -1, 0, 1, 2].map(k => this._loadSlide(index + k));
   }

   _initEvents() {
      this.$prev.addEventListener('click', e => {
         e.preventDefault();
         this.prev();
      });

      this.$next.addEventListener('click', e => {
         e.preventDefault();
         this.next();
      });
   }

   _loadSlide(index) {
      swapImgSources(this.$images[this._loopIndex(index)]);
   }

   _loopIndex(val) {
      const l = this.$slides.length;
      return (val < 0) ? val - Math.floor(val / l) * l : val % l;
   }

   _getElements() {
      this.$curIndex = this.$root.querySelector('.slider-cur-index-js');
      this.$prev = this.$root.querySelector('.slider-prev-js');
      this.$next = this.$root.querySelector('.slider-next-js');
      this.$slides = [...this.$root.querySelectorAll('.slider-slide-js')];
      this.$images = this.$slides.map(e => e.querySelector('.slider-slide-img-js'));
   }
}